
export default {
  name: 'HomeLedBlueprint',
  data() {
    return {
      opponent: 'halogen',
      opponents: [
        { key: 'halogen', versus: 'pages.index.ledComparison.versusHalogen' },
        { key: 'cheap', versus: 'pages.index.ledComparison.versusCheap' },
      ],
      bulbPhoto: require('~/assets/images/thallium-h7-led.webp'),
      leftKeys: ['brightness', 'beam', 'service'],
      rightKeys: ['colorTemperature', 'lifespan'],
    }
  },
  methods: {
    nbsp(text) {
      return text.replace(/(\d) /g, '$1 ')
    },
  },
}
